import { FileExcelOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Empty,
  notification,
  Skeleton,
  Tooltip,
  Layout,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import {
  CommandBar,
  MessageBar,
  MessageBarType,
  ProgressIndicator,
} from "@fluentui/react";
import React, { createContext, useEffect, useRef } from "react";
import { useContext } from "react";
import { Clock } from "react-feather";
import moment from "moment";
import { FilterCallOut } from "../../shared/FilterCallOut";
import TargetStore from "../productiontarget/store/TargetStore";
import CommercialStore from "../settings/store/CommercialStore";
import { toAntPickerDate } from "../../Utility/modules/datePicker";
import { toJS } from "mobx";
import { Observer, observer } from "mobx-react-lite";
import { SubPageHeaderTitle } from "../../shared/SubPageHeaderTitle";
import formatNumber from "accounting-js/lib/formatNumber";
import { ContractRollover } from "./ContractRollover";

const { Content } = Layout;
const targetstore = createContext(TargetStore);
const commercialStoreCtx = createContext(CommercialStore);
export const Contract = observer(() => {
  const targetStore = useContext(targetstore);
  const commercialStore = useContext(commercialStoreCtx);
  const contractGrid = useRef(null);
  useEffect(() => {
    async function loadContractObligations() {
      await commercialStore.loadContractObligations(
        commercialStore.contractYear,
        targetStore.mainStore.assetContextId
      );
    }
    try {
      loadContractObligations();
    } catch (error) {
      notification.error({
        key: "error",
        message: "SPARS Feedback",
        description: error.message,
      });
    }
  }, []);
  const rowSelected = (grid) => {
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      commercialStore.selRow = toJS(selrow.data);
    }
  };
  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        thousand: ",",
      });
    }
  };
  const onCellEditingStopped = ({ node, value }) => {
    console.log({ obligation: node.data.obligation, value });
    commercialStore.disableSave = false;
  };

  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        rowDrag: true,
        valueGetter: function (params) {
          return "";
        },
        width: 80,
        checkboxSelection: true,
        pivot: false,
      },
      {
        headerName: "Contract Centre",
        field: "contractCenter",

        sortable: true,
        resizable: true,
      },
      {
        headerName: "Unit",
        field: "unit",

        sortable: true,
        resizable: true,
      },
      {
        headerName: "Contract Obligation",
        field: "obligation",
        width: 100,
        resizable: true,
        sortable: true,
        cellStyle: {
          textAlign: "right",
          backgroundColor: "#FFF4CE",
        },
        editable: true,
        type: "numberColumn",
        valueFormatter: formatDigitOil,
      },

      {
        headerName: "Audit",

        children: [
          {
            headerName: "Set By",
            field: "uploadedBy",

            sortable: true,
            resizable: true,
          },
          {
            headerName: "Set On",
            field: "uploadedOn",
            sortable: true,
            resizable: true,

            cellRendererFramework: function (props) {
              if (targetStore.hasImported) return null;
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            },
          },
        ],
      },
    ],
  };
  return (
    <Layout>
      <Content>
        <Layout
          style={{
            background: "#fff",
            padding: "10px",
            borderTop: `2px solid ${
              targetStore.mainStore.assetContextId === 2
                ? "rgb(242, 156, 31)"
                : "rgb(47, 168, 204)"
            }`,
          }}
        >
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <SubPageHeaderTitle
                  title={` Commercial ${commercialStore.contractYear} Contract Obligations `}
                />
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <CommandBar
                  items={[
                    {
                      key: "filtertdd",
                      onRenderIcon: () => <FilterCallOut />,
                    },
                    {
                      key: "access",

                      text: (
                        <Tooltip title="perform quick query production and evacuation target by year">
                          Target Year{" "}
                          <DatePicker
                            picker="year"
                            defaultValue={toAntPickerDate(`01-01-${targetStore.targetYear}`, "MM-DD-YYYY")}
                            allowClear={false}
                            format={"YYYY"}
                            onChange={async (date, dateString) => {
                              try {
                                commercialStore.contractYear =
                                  Number(dateString);
                                await commercialStore.loadContractObligations(
                                  commercialStore.contractYear,
                                  targetStore.mainStore.assetContextId
                                );
                              } catch (error) {
                                notification.error({
                                  key: "error",
                                  message: "SPARS Feedback",
                                  description: error.message,
                                });
                              }
                            }}
                          />
                        </Tooltip>
                      ),

                      onRenderIcon: () => <Clock className="qicon" />,
                    },
                    {
                      key: "spacere",
                      onRender: () => <div style={{ width: "50px" }} />,
                    },
                  ]}
                  farItems={[
                    {
                      key: "progress",
                      buttonStyles: { root: { width: "350px" } },
                      commandBarButtonAs: () => (
                        <Observer>
                          {() => (
                            <>
                              {commercialStore.isSubmitting && (
                                <ProgressIndicator
                                  description="saving,please wait..."
                                  styles={{
                                    root: {
                                      width: "500px",
                                      textAlign: "center",
                                      marginRight: "50px",
                                    },
                                  }}
                                ></ProgressIndicator>
                              )}
                            </>
                          )}
                        </Observer>
                      ),
                    },
                    {
                      key: "savebtn",
                      onRender: () => (
                        <Observer>
                          {() => (
                            <Button
                              type="primary"
                              style={{ marginRight: "50px" }}
                              disabled={commercialStore.disableSave}
                              onClick={async () => {
                                try {
                                  await commercialStore.save();
                                  notification.success({
                                    message: "SPARS Feedback",
                                    description: `${commercialStore.contractYear} contract obligations saved successfully`,
                                  });
                                } catch (error) {
                                  notification.error({
                                    key: "error",
                                    message: "SPARS Feedback",
                                    description: error.message,
                                  });
                                }
                              }}
                            >
                              Save Target
                            </Button>
                          )}
                        </Observer>
                      ),
                    },
                    {
                      key: "group4",

                      text: (
                        <Tooltip title="Export displayed production and evacuation target to excel">
                          Export to Excel
                        </Tooltip>
                      ),
                      name: "group",
                      onRenderIcon: () => (
                        <FileExcelOutlined className="qicon" />
                      ),

                      onClick: () => {
                        contractGrid.current.api.exportDataAsExcel({
                          sheetName: "contract_obligations",
                          allColumns: true,

                          skipFooters: false,
                          skipGroups: false,
                          skipHeader: false,
                          skipPinnedTop: false,
                          skipPinnedBottom: false,
                          skipColumnGroupHeaders: false,
                          skipColumnHeaders: false,
                          columnGroups: true,
                          fileName: `${targetStore.mainStore.assetContextName}_${targetStore.targetYear}_contract_obligations`,
                        });
                      },
                    },
                  ]}
                ></CommandBar>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                {" "}
                {commercialStore.isLoading ? (
                  <>
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                  </>
                ) : (
                  <div
                    className="ag-theme-balham"
                    style={{
                      minHeight: "50vh",
                      height: "65vh",
                      width: "100%",
                      maxHeight: "80vh",
                    }}
                  >
                    {commercialStore.contractObligations.size > 0 ? (
                      <>
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            <MessageBar
                              messageBarType={MessageBarType.warning}
                              isMultiline={false}
                            >
                              Double click contract obligation column to edit.
                            </MessageBar>
                          </div>
                        </div>

                        <AgGridReact
                          rowData={[
                            ...commercialStore.contractObligations.values(),
                          ]}
                          ref={contractGrid}
                          gridOptions={{
                            defaultColDef: {
                              sortable: true,
                              filter: true,
                              enableValue: true,
                            },

                            rowSelection: "single",

                            columnDefs: gridcolumnDefs.columnDefs,
                            animateRows: true,

                            columnTypes: {
                              numberColumn: {
                                width: 130,
                                filter: "agNumberColumnFilter",
                              },
                              medalColumn: {
                                width: 100,
                                columnGroupShow: "open",
                                filter: false,
                              },
                              nonEditableColumn: { editable: false },
                            },
                          }}
                          rowSelection="single"
                          onSelectionChanged={rowSelected}
                          onCellEditingStopped={onCellEditingStopped}
                          copyHeadersToClipboard={true}
                          overlayLoadingTemplate={`${(
                            <span class="ag-overlay-loading-center">
                              Please wait while your rows are loading
                            </span>
                          )}`}
                          overlayNoRowsTemplate={
                            '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
                          }
                        ></AgGridReact>
                      </>
                    ) : (
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          {" "}
                          <NoObligations
                            targetStore={targetStore}
                            year={commercialStore.contractYear}
                            assetId={targetStore.mainStore.assetContextId}
                            commercialStore={commercialStore}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <ContractRollover />
              </div>
            </div>
          </div>
        </Layout>
      </Content>
    </Layout>
  );
});

function NoObligations({ targetStore, assetId, year, commercialStore }) {
  return (
    <div className="ms-Grid" dir="ltr" style={{}}>
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{
            height: "70vh",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: "column",
          }}
        >
          <Empty
            description={`${targetStore.mainStore.assetContextName} Contract Obligations  for ${year} has not been set`}
          />
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm6"
              style={{ textAlign: "right", paddingTop: "20px" }}
            >
              {" "}
              <Button
                type="danger"
                onClick={async () => {
                  try {
                    await CommercialStore.rollover(year, assetId);
                  } catch (error) {
                    notification.error({
                      key: "error",
                      message: "SPARS Feedback",
                      description: error.message,
                    });
                  }
                }}
              >
                {`Set New ${targetStore.mainStore.assetContextName}  Contract Obligations for ${year}`}
              </Button>
            </div>
            <div
              className="ms-Grid-col ms-sm5"
              style={{
                textAlign: "left",
                paddingTop: "20px",
                marginLeft: "10px",
              }}
            >
              {" "}
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={() => {
                  commercialStore.showRolloverDialog = true;
                }}
              >
                {`Rollover ${targetStore.mainStore.assetContextName} Contract Obligations`}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

